var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-us" },
    [
      _c(
        "v-row",
        { attrs: { variant: "flex" } },
        [
          _c("v-column", { attrs: { large: 12 } }, [
            _c(
              "div",
              { staticClass: "contact-us__inner" },
              [
                _c("v-typo", {
                  staticClass: "contact-us__headline",
                  attrs: { variant: "h2" },
                  domProps: { innerHTML: _vm._s(_vm.$t("contactUs.headline")) }
                }),
                _vm._v(" "),
                _c(
                  "v-button",
                  {
                    staticClass: "contact-us__button",
                    attrs: {
                      to: _vm.path("contact"),
                      element: "router-link",
                      variant: "primary"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("button.contactUs")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }